module.exports = __webpack_public_path__ + "images/Windows_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Windows_hover.png
// module id = 394
// module chunks = 0 1